import {
	baseUrl,
	cvoUrl,
	ssoUrl,
	wechatUrl,
	cdnUrl,
} from './env'
import axios from 'axios';
import store from '../store/'
import Vue from 'vue'
import util from './util'
// axios.defaults.withCredentials=true

//定义API mock 切换
export const sconfig={
	all:false,
	common:false,
	enroll:false,
	order:false,
	vo:false,
}

export const SSO='SSO';
export const CVO='CVO';
export const HK='HK';
export const Mobile='Mobile'
 /** 
  * 代替原来的fetch方法，原方法在Mac下会报错。
  */
export const fetch = (type = 'GET', url = '', params = {},domain) => {
	let withCredentials = false;
	if (domain === SSO) {
		url = ssoUrl + url;
		url += '&channel=HK'
	}else if (domain === HK) {
		url = baseUrl + url;
		url += '&channel=HK'
		// withCredentials = true;
	}else if (domain === CVO) {
		url = cvoUrl + url;
		url += '&channel=HK'
	}else {
		url = baseUrl + url;
		url += '&channel=HK'
	}

	// 格式化URL，params
	url = formatURL(url)
	params = formatParams(params)
	if(type == 'GET'){
		return axios.get(url, { params: params,withCredentials}).then(res => {
			if(res.status !== 200) {
				return null;
			} else {
				if (res.data?.response?.time) {
					window.time = res.data.response.time;
				}
				window.basetime = new Date();
				checkUser(res.data,url)
				return res.data;
			}
		}).catch((error) => {
			console.log('error:' + error);
		});
	}
	else if(type == 'POST'){
		return axios.post(url, { paramss: params,withCredentials}).then(res => {
			if(res.status !== 200) {
				return null;
			} else {
				if (res.data?.response?.time) {
					window.time = res.data.response.time;
				}
				window.basetime = new Date();
				checkUser(res.data,url)
				return res.data;
			}
		}).catch((error) => {
			console.log('error:' + error);
		});
	}
}
function formatURL(url){
	return url.replace(/null|undefined/g,matched=>{
		return ''
	})
}
function formatParams(params){
	for (let value in params) {
		if (params[value] == null || params[value] == undefined)params[value] = ''
		
	}
	return params
}

function getQueryString(url,name) {
	var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
	if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
	return null;
}

function checkUser(res,url){

	if(res&&res.response&&res.response.code==-1&&res.response.errorCode=='0005'){
		var m=getQueryString(url,'m')
		if(m=='so002'||m=='MI_01'||m=='Home_08'){
			return 
		}
		store.dispatch('setConfigKeyAction','userInfo')
		//location.reload();
		let redirect;
		let toUrl = Vue.prototype.$path
		let regex = /token=\w*(&|$)|(\?|&)token=\w*$/;
		toUrl = toUrl.replace(regex, "");
		if (process.env.NODE_ENV === 'development') {
			redirect = escape(`http://localhost:9000/#${toUrl}`);
			location.href = `${ssoUrl}/sso/index.html#/hklogin?from=hk&redirect=${redirect}`;
		} else {
			redirect = escape(`${baseUrl}/vo/index.html#${toUrl}`);
			location.href = `${ssoUrl}/sso/index.html#/hklogin?from=hk&redirect=${redirect}`;
		}
	}
}


/**
 * 创建临时数据
 */
export const setpromise = data => {
	return new Promise((resolve, reject) => {
		resolve(data)
	})
};
/**
 * doTERRA 通用API接口
 */
export const fetchForDoterra = (type = 'GET', method, token, uid, params = {}) => {
	return fetch(type, '/api/v1/app_api?version=' + process.env.VUE_APP_VERSION + '&token=' + token + '&m=' + method + '&uid=' + uid, params);
};
export const fetchForHK = (type = 'GET', method, token, uid, params = {}) => {
    return fetch(type, '/api/v1/client_api?version=' + process.env.VUE_APP_VERSION + '&token=' + token + '&m=' + method + '&uid=' + uid, params, HK);
}
export const fetchForHKK = (type = 'GET', method, token, VipNo, params = {}) => {
	return fetch(type, '/api/v1/client_api?version=' + process.env.VUE_APP_VERSION + '&token=' + token + '&m=' + method + '&VipNo=' + VipNo, params, HK);
};
export const fetchForCVO = (type = 'GET', method, token, VipNo, params = {}) => {
	return fetch(type, '/api/v1/client_api?version=' + process.env.VUE_APP_VERSION + '&token=' + token + '&m=' + method + '&VipNo=' + VipNo, params, CVO);
};
export const fetchForDoterraNoLogin = (type = 'GET', method, token, VipNo, params = {}, domain) => {
	return fetch(type, '/api/v1/app_api?version=' + process.env.VUE_APP_VERSION + '&token=' + token + '&m=' + method + '&VipNo=' + VipNo, params, domain);
};
export const fetchForCDN = async (type = 'GET',method,token,uid,params,sourceFetch) => {
	if (store.getters.useCDN) {
		let path = Object.values(params).filter(item=>item).join('/')
		let url = `${cdnUrl}/website/${method}/${path}`
		return axios.get(url, {
			withCredentials:false,
			headers:{
				'cache-control': 'no-cache'
			}
		}).then(res => {
			if(res.status !== 200) {
				return null;
			} else {
				checkUser(res.data,url)
				return res.data;
			}
		}).catch((error) => {
			return null;
		});
	} else {
		sourceFetch = sourceFetch || fetchForDoterra
		return sourceFetch(type,method,token,uid,params)
	}
}